import Graph from "./section/Graph";
import Faq from "../Home/Section/Faq";
import { Link } from "react-router-dom";
import ZeussToken from "../../../Contract/zeussToken.json";
const Staking = () => {
  return (
    <>
      <div className="topbar">
        <h4>
          $ZFORGE Contract Address{" "}
          <Link
            target="_blank"
            to={`https://etherscan.io/token/${ZeussToken.address}`}
          >
            {ZeussToken.address}
          </Link>
        </h4>
      </div>
      <div className="wrapper">
        <div className="pageback">
          <section className="Terms Contact">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="heading text-center">
                    <h4>Welcome to $ZFORGEStaking</h4>
                    <p>
                      Unlock the potential of your $ZFORGE Tokens with our
                      staking platform. Earn rewards, support the ZForge
                      ecosystem, and enjoy exclusive benefits—all while your
                      tokens work for you. Start staking today and be part of
                      the future of gaming!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Graph />
          <Faq />
        </div>
      </div>
    </>
  );
};
export default Staking;
